import { Button } from "antd";
import React from "react";

export interface CustomButtonProps {
    label?: string;
    icon?: React.ReactNode;
    onClick?: () => void;
    variant?: 'primary' | 'secondary' | 'tertiary' | 'danger';
    htmlType? : 'submit' | 'button';
    disabled?: boolean;
    height?: number;
    maxWidth?: number;
    fontSize?: number;
}

const CustomButton: React.FC<CustomButtonProps> = ({ label, icon, onClick, variant = 'primary', htmlType='button', disabled=false, height, maxWidth = 200, fontSize = 14 }) => {

    const buttonThemes = {
        primary: {
            backgroundColor: disabled ? '#808080' : '#0958d9' ,
            color: disabled ? '#545353': 'white',
            border: 'none'
            
        },
        secondary: {
            backgroundColor: 'white',
            color: '#0958d9',
            border: '1px solid #0958d9'
        },
        tertiary: {
            backgroundColor: 'green',
            color: 'white',
            border: 'none'
        },
        danger: {
            backgroundColor: disabled ? '#808080' : 'red',
            color: 'white',
            borderColor: 'red',
            border: 'none'
        },
    };
    
    const getButtonStyle = (variant: 'primary' | 'secondary' | 'tertiary' | 'danger') => ({
        backgroundColor: buttonThemes[variant].backgroundColor,
        color: buttonThemes[variant].color,
        border: buttonThemes[variant].border,
        padding: '8px 32px',
        height: height ? `${height}px` : 'auto',
        fontSize: `${fontSize}px`,
        fontWeight: 'bold',
        borderRadius: '0px',
        width: '100%',
        maxWidth: `${maxWidth}px`,
    });

    return (
        <Button onClick={onClick} disabled={disabled} style={getButtonStyle(variant)} icon={icon} htmlType={htmlType}>
            {label?.toLocaleUpperCase()}
        </Button>
    );
};

export default CustomButton;